import { optionSubcategory_groups } from './groupsSubCategory.locstring.json';
import { GroupOptions } from 'owa-groups-option';
import { OptionSubCategory } from 'owa-options-core';

let groupsSubCategory: OptionSubCategory = {
    key: 'groups',
    titleStringKey: optionSubcategory_groups,
    options: [GroupOptions],
};

export default groupsSubCategory;
